export const SET_COMPONENTS_SEARCH = 'Editor/Menu/SET_COMPONENT_SEARCH';

export const SET_PALETTE_APPEARANCE = 'Editor/Menu/SET_PALETTE_APPEARANCE';

export const SET_PALETTE_LAYERS_HIDDEN = 'Editor/Menu/SET_PALETTE_LAYERS_HIDDEN';

export const SET_PALETTE_TAB = 'Editor/Menu/SET_PALETTE_TAB';

export const SET_TOOLBOX_TAB = 'Editor/Menu/SET_TOOLBOX_TAB';

export const SET_PLACEMENT_MODE = 'Editor/Menu/SET_PLACEMENT_MODE';

export const SET_PREVIEW_SELECTOR = 'Editor/Menu/SET_PREVIEW_SELECTOR';

export const SET_PREVIEW_SELECTOR_LOCATION = 'Editor/Menu/SET_PREVIEW_SELECTOR_LOCATION';

export const SET_FORCE_PLACEMENTS_TAB = 'Editor/Menu/SET_FORCE_PLACEMENTS_TAB';
